import * as React from 'react'

import { SettingsPage } from '@sales-center/components'
import CampaignTrackingProvider from './CampaignTrackingProvider'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { CampaignTrackingFormWrapper } from './CampaignTrackingFormWrapper'

export function CampaignTrackingSettings() {
  const tidalThemeActive = useTidalThemeActive()
  return (
    <SettingsPage title="Integrations" padding="40px">
      {tidalThemeActive ? (
        <CampaignTrackingProvider />
      ) : (
        <CampaignTrackingFormWrapper />
      )}
    </SettingsPage>
  )
}
